class KRProductSpotlight {
  constructor(section) {
    this.section = section;

    this.autoplay = section.dataset.autoplay === "true";
    this.speed = Number(section.dataset.speed) || 5000;

    this.images = [...section.querySelectorAll(".kr-product-spotlight__image")];

    if (!this.autoplay || this.images.length <= 1) return;

    this.current = 0;

    this.preloadImages();

    this.bindVisibility();

    this.start();
  }

  preloadImages() {
    this.images.forEach((image) => {
      const img = image.querySelector("img");

      if (!img) return;

      const preload = new Image();
      preload.src = img.currentSrc || img.src;
    });
  }

  start() {
  clearInterval(this.interval);

  this.interval = setInterval(() => {
    this.next();
  }, this.speed);
}
  

  next() {
    this.images[this.current].classList.remove("is-active");

    this.current = (this.current + 1) % this.images.length;

    this.images[this.current].classList.add("is-active");
  }

  bindVisibility() {
  document.addEventListener("visibilitychange", () => {

    if (document.hidden) {

      clearInterval(this.interval);

    } else {

      this.start();

    }

  });
}



}

function initKRSpotlight() {
  document
    .querySelectorAll(".kr-product-spotlight")
    .forEach((section) => {

      if (!section.dataset.initialized) {
        section.dataset.initialized = "true";
        new KRProductSpotlight(section);
      }

    });
}

document.addEventListener("DOMContentLoaded", initKRSpotlight);

document.addEventListener("shopify:section:load", initKRSpotlight);